import './tag.scss';

function Tag(props) {
  return (
    <div class='tag'>{props.tag}</div>
  );
}

export default Tag;
